// extracted by mini-css-extract-plugin
module.exports = {"vWhite2":"#fafafa","list":"ReportsFreedomTurnover_list__26qwS","item":"ReportsFreedomTurnover_item__2wzxd","body":"ReportsFreedomTurnover_body__3mWx7"};